import { render } from "./Renewable.vue?vue&type=template&id=18848e23"
import script from "./Renewable.vue?vue&type=script&lang=js"
export * from "./Renewable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__